import { Grid, Paper } from '@mui/material';

import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()(theme => ({
  paper: {
    padding: theme.spacing(3),
  }
}));

export type MultiButtonAndImageActionItemProps = {
  image: React.ReactNode;
};

export const MultiButtonAndImageActionItem: React.FC<MultiButtonAndImageActionItemProps> = ({ image, children }) => {
  const { classes } = useStyles();

  return (
    <Paper elevation={1} className={classes.paper}>
      <Grid container spacing={2}>
        <Grid
          size={{
            xs: 12,
            sm: 6
          }}>
          {image}
        </Grid>
        <Grid
          size={{
            xs: 12,
            sm: 6
          }}>
          {children}
        </Grid>
      </Grid>
    </Paper>
  );
};
